import { render, staticRenderFns } from "./VendorEdit.vue?vue&type=template&id=9b924306&scoped=true&"
import script from "./VendorEdit.vue?vue&type=script&lang=js&"
export * from "./VendorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b924306",
  null
  
)

export default component.exports